import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
import moment from "moment";
const initialState = {
  managerLogs: [],
  userSummary: [],
  managerLogsBySalesTeamAndDate: {},
  managerLogsDetailedMap: [],
};
let URL = endpoints.managerLogs;
let URL1 = endpoints.checkin;
const managerLogsSlice = createSlice({
  name: "managerLogs",
  initialState,
  reducers: {
    managerLogsSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        managerLogs: row,
      };
    },

    managerLogsDetailedMapSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        managerLogsDetailedMap: row,
      };
    },

    managerLogsBySalesTeamAndDateSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        managerLogsBySalesTeamAndDate: row,
      };
    },

    userSummarySuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        userSummary: row,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const {
  managerLogsSuccess,
  userSummarySuccess,
  managerLogsBySalesTeamAndDateSuccess,
  managerLogsDetailedMapSuccess,
} = managerLogsSlice.actions;
export default managerLogsSlice.reducer;

export const getManagerLogs =
  ({ fromDate, toDate }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL + "/get-between-dates?fromDate=" + fromDate + "&toDate=" + toDate,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((managerLogHeaderObj, index) => {
              const dateObject = moment(managerLogHeaderObj.date, "DD-MM-YYYY");
              const formattedDate = dateObject.format("DD MMM");
              let managerLogsData = {
                index: index + 1,
                id: managerLogHeaderObj.id === null ? "" : managerLogHeaderObj.id,
                date:
                  managerLogHeaderObj.date === null
                    ? ""
                    : managerLogHeaderObj.date,

                day: formattedDate,
                managerLogs:
                  managerLogHeaderObj.managerLogs === null
                    ? ""
                    : managerLogHeaderObj.managerLogs.map(
                      (managerLogObj, index) => {
                        let managerLogsListData = {
                          index: index + 1,
                          id: managerLogObj.id === null ? "" : managerLogObj.id,
                          salesTeamId:
                            managerLogObj.salesTeamId === null
                              ? ""
                              : managerLogObj.salesTeamId,
                          workingTypeId:
                            managerLogObj.workingType === null
                              ? ""
                              : managerLogObj.workingType.id,
                          workingTypeName:
                            managerLogObj.workingType === null
                              ? ""
                              : managerLogObj.workingType.name,
                          areaId:
                            managerLogObj.areaId === null
                              ? ""
                              : managerLogObj.areaId,
                          areaName:
                            managerLogObj.areaName === null
                              ? ""
                              : managerLogObj.areaName,
                          outletId:
                            managerLogObj.outletId === null
                              ? ""
                              : managerLogObj.outletId,
                          entityName:
                            managerLogObj.entityName === null
                              ? ""
                              : managerLogObj.entityName,
                          stockStakeHolderId:
                            managerLogObj.stockStakeHolderId === null
                              ? ""
                              : managerLogObj.stockStakeHolderId,
                          description:
                            managerLogObj.description === null
                              ? ""
                              : managerLogObj.description,
                          fromTime:
                            managerLogObj.fromTime === null
                              ? ""
                              : managerLogObj.fromTime,
                          toTime:
                            managerLogObj.toTime === null
                              ? ""
                              : managerLogObj.toTime,
                          timeDifference:
                            managerLogObj.timeDifference === null
                              ? ""
                              : managerLogObj.timeDifference,
                          date:
                            managerLogObj.date === null
                              ? ""
                              : managerLogObj.date,
                          managerStartLat:
                            managerLogObj.managerStartLat === null
                              ? ""
                              : managerLogObj.managerStartLat,
                          managerStartLong:
                            managerLogObj.managerStartLong === null
                              ? ""
                              : managerLogObj.managerStartLong,
                          startAddress:
                            managerLogObj.startAddress === null
                              ? ""
                              : managerLogObj.startAddress,
                          managerEndLat:
                            managerLogObj.managerEndLat === null
                              ? ""
                              : managerLogObj.managerEndLat,
                          managerEndLong:
                            managerLogObj.managerEndLong === null
                              ? ""
                              : managerLogObj.managerEndLong,
                          endAddress:
                            managerLogObj.endAddress === null
                              ? ""
                              : managerLogObj.endAddress,
                          otherTaskId:
                            managerLogObj.otherTask === null
                              ? ""
                              : managerLogObj.otherTask.id,
                          otherTaskName:
                            managerLogObj.otherTask === null
                              ? ""
                              : managerLogObj.otherTask.name,
                          outletLatitude:
                            managerLogObj.outletLatitude === null
                              ? ""
                              : managerLogObj.outletLatitude,
                          outletLongitude:
                            managerLogObj.outletLongitude === null
                              ? ""
                              : managerLogObj.outletLongitude,
                          extra1:
                            managerLogObj.extra1 === null
                              ? ""
                              : managerLogObj.extra1,
                          extraIds:
                            managerLogObj.extraIds === null
                              ? ""
                              : managerLogObj.extraIds,
                          isVisitIsOrder:
                            managerLogObj.isVisitIsOrder === null
                              ? ""
                              : managerLogObj.isVisitIsOrder,
                          checkInOut:
                            managerLogObj.checkInOut === null
                              ? ""
                              : managerLogObj.checkInOut,
                          insertedUserId:
                            managerLogObj.insertedUserId === null
                              ? ""
                              : managerLogObj.insertedUserId,
                          insertDateTime:
                            managerLogObj.insertDateTime === null
                              ? ""
                              : managerLogObj.insertDateTime,
                          salesPersonName:
                            managerLogObj.salesPersonName === null
                              ? ""
                              : managerLogObj.salesPersonName,
                          salesTeamIsActiveFlag:
                            managerLogObj.salesTeamIsActiveFlag === null
                              ? ""
                              : managerLogObj.salesTeamIsActiveFlag,
                        };
                        return managerLogsListData;
                      }
                    ),
              };

              return managerLogsData;
            });
            dispatch(managerLogsSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getManagerLogsBySalesTeamIdsUpdated =
  ({ fromDate, toDate, salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/logs-and-real-time-data-time-line-updated?fromDate=" +
            fromDate +
            "&toDate=" +
            toDate +
            "&salesTeamId=" +
            salesTeamId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((managerLogHeaderObj, index) => {
              const dateObject = moment(managerLogHeaderObj.date, "DD-MM-YYYY");
              const formattedDate = dateObject.format("DD MMM");
              let managerLogsData = {
                index: index + 1,
                id: managerLogHeaderObj.id === null ? "" : managerLogHeaderObj.id,
                date:
                  managerLogHeaderObj.date === null
                    ? ""
                    : managerLogHeaderObj.date,

                salesTeamId:
                  managerLogHeaderObj.salesTeam !== null &&
                    managerLogHeaderObj.areaId !== null
                    ? managerLogHeaderObj.salesTeam.id
                    : "",

                salesTeamName:
                  managerLogHeaderObj.salesTeam !== null &&
                    managerLogHeaderObj.salesTeam.name !== null
                    ? managerLogHeaderObj.salesTeam.name
                    : "",
                day: formattedDate,

                salesTeamType:
                  managerLogHeaderObj.salesTeam !== null &&
                    managerLogHeaderObj.salesTeam.stockStakeHolderType !== null
                    ? managerLogHeaderObj.salesTeam.stockStakeHolderType.name
                    : "",

                beatNames:
                  managerLogHeaderObj.beatNames !== null
                    ? managerLogHeaderObj.beatNames
                    : "",

                areaNames:
                  managerLogHeaderObj.areaNames !== null
                    ? managerLogHeaderObj.areaNames
                    : "",

                currentMonthTargetAmount:
                  managerLogHeaderObj.currentMonthTargetAmount !== null
                    ? managerLogHeaderObj.currentMonthTargetAmount
                    : "",

                dayWiseTargetAmount:
                  managerLogHeaderObj.dayWiseTargetAmount !== null
                    ? managerLogHeaderObj.dayWiseTargetAmount
                    : "",

                productiveOrderCount:
                  managerLogHeaderObj.productiveOrderCount !== null
                    ? managerLogHeaderObj.productiveOrderCount
                    : "",

                totalAmount:
                  managerLogHeaderObj.totalAmount !== null
                    ? managerLogHeaderObj.totalAmount
                    : "",

                totalOutletCount:
                  managerLogHeaderObj.totalOutletCount !== null
                    ? managerLogHeaderObj.totalOutletCount
                    : "",

                unvisitedOutletCount:
                  managerLogHeaderObj.unvisitedOutletCount !== null
                    ? managerLogHeaderObj.unvisitedOutletCount
                    : "",

                visitedOutletCount:
                  managerLogHeaderObj.visitedOutletCount !== null
                    ? managerLogHeaderObj.visitedOutletCount
                    : "",

                zeroOrderCount:
                  managerLogHeaderObj.zeroOrderCount !== null
                    ? managerLogHeaderObj.zeroOrderCount
                    : "",

                beats:
                  managerLogHeaderObj.beats === null
                    ? ""
                    : managerLogHeaderObj.beats.map((beatDataObj, index) => {
                      let beatData = {
                        index: index + 1,
                        id: beatDataObj.id === null ? "" : beatDataObj.id,
                        beatName:
                          beatDataObj.beatName !== null
                            ? beatDataObj.beatName
                            : "",
                        areaName:
                          beatDataObj.areaName === null
                            ? ""
                            : beatDataObj.areaName,
                      };
                      return beatData;
                    }),

                managerLogs:
                  managerLogHeaderObj.managerLogs === null
                    ? ""
                    : managerLogHeaderObj.managerLogs.map(
                      (managerLogObj, index) => {
                        let managerLogsListData = {
                          index: index + 1,
                          id: managerLogObj.id === null ? "" : managerLogObj.id,
                          salesTeamId:
                            managerLogObj.salesTeamId === null
                              ? ""
                              : managerLogObj.salesTeamId,
                          workingTypeId:
                            managerLogObj.workingType === null
                              ? ""
                              : managerLogObj.workingType.id,
                          workingTypeName:
                            managerLogObj.workingType === null
                              ? ""
                              : managerLogObj.workingType.name,
                          areaId:
                            managerLogObj.areaId === null
                              ? ""
                              : managerLogObj.areaId,
                          areaName:
                            managerLogObj.areaName === null
                              ? ""
                              : managerLogObj.areaName,
                          remoteOrder:
                            managerLogObj.remoteOrder === null
                              ? ""
                              : managerLogObj.remoteOrder,
                          outletId:
                            managerLogObj.outletId === null
                              ? ""
                              : managerLogObj.outletId,
                          entityName:
                            managerLogObj.entityName === null
                              ? ""
                              : managerLogObj.entityName,
                          stockStakeHolderId:
                            managerLogObj.stockStakeHolderId === null
                              ? ""
                              : managerLogObj.stockStakeHolderId,
                          description:
                            managerLogObj.description === null
                              ? ""
                              : managerLogObj.description,
                          fromTime:
                            managerLogObj.fromTime === null
                              ? ""
                              : managerLogObj.fromTime,
                          toTime:
                            managerLogObj.toTime === null
                              ? ""
                              : managerLogObj.toTime,
                          timeDifference:
                            managerLogObj.timeDifference === null
                              ? ""
                              : managerLogObj.timeDifference,
                          date:
                            managerLogObj.date === null
                              ? ""
                              : managerLogObj.date,
                          managerStartLat:
                            managerLogObj.managerStartLat === null
                              ? ""
                              : managerLogObj.managerStartLat,
                          managerStartLong:
                            managerLogObj.managerStartLong === null
                              ? ""
                              : managerLogObj.managerStartLong,
                          startAddress:
                            managerLogObj.startAddress === null
                              ? ""
                              : managerLogObj.startAddress,
                          managerEndLat:
                            managerLogObj.managerEndLat === null
                              ? ""
                              : managerLogObj.managerEndLat,
                          managerEndLong:
                            managerLogObj.managerEndLong === null
                              ? ""
                              : managerLogObj.managerEndLong,
                          endAddress:
                            managerLogObj.endAddress === null
                              ? ""
                              : managerLogObj.endAddress,
                          otherTaskId:
                            managerLogObj.otherTask === null
                              ? ""
                              : managerLogObj.otherTask.id,
                          otherTaskName:
                            managerLogObj.otherTask === null
                              ? ""
                              : managerLogObj.otherTask.name,
                          outletLatitude:
                            managerLogObj.outletLatitude === null
                              ? ""
                              : managerLogObj.outletLatitude,
                          outletLongitude:
                            managerLogObj.outletLongitude === null
                              ? ""
                              : managerLogObj.outletLongitude,
                          extra1:
                            managerLogObj.extra1 === null
                              ? ""
                              : managerLogObj.extra1,
                          extraIds:
                            managerLogObj.extraIds === null
                              ? ""
                              : managerLogObj.extraIds,
                          isVisitIsOrder:
                            managerLogObj.isVisitIsOrder === null
                              ? ""
                              : managerLogObj.isVisitIsOrder,
                          checkInOut:
                            managerLogObj.checkInOut === null
                              ? ""
                              : managerLogObj.checkInOut,
                          insertedUserId:
                            managerLogObj.insertedUserId === null
                              ? ""
                              : managerLogObj.insertedUserId,
                          insertDateTime:
                            managerLogObj.insertDateTime === null
                              ? ""
                              : managerLogObj.insertDateTime,
                          salesPersonName:
                            managerLogObj.salesPersonName === null
                              ? ""
                              : managerLogObj.salesPersonName,

                          salesTeamPersonAreaIds:
                            managerLogObj.salesTeamPersonAreaIds === null
                              ? ""
                              : managerLogObj.salesTeamPersonAreaIds,

                          stockStakeHolderTypeName:
                            managerLogObj.stockStakeHolderTypeName === null
                              ? ""
                              : managerLogObj.stockStakeHolderTypeName,

                          stockStakeHolderTypeId:
                            managerLogObj.stockStakeHolderTypeId === null
                              ? ""
                              : managerLogObj.stockStakeHolderTypeId,

                          salesTeamPersonAddress:
                            managerLogObj.salesTeamPersonAddress === null
                              ? ""
                              : managerLogObj.salesTeamPersonAddress,

                          salesTeamPersonName:
                            managerLogObj.salesTeamPersonName === null
                              ? ""
                              : managerLogObj.salesTeamPersonName,

                          salesTeamPersonId:
                            managerLogObj.salesTeamPersonId === null
                              ? ""
                              : managerLogObj.salesTeamPersonId,

                          image:
                            managerLogObj.image === null
                              ? ""
                              : managerLogObj.image,

                          stockStakeHolderTypePrefix:
                            managerLogObj.stockStakeHolderTypePrefix === null
                              ? ""
                              : managerLogObj.stockStakeHolderTypePrefix,

                          salesTeamIsActiveFlag:
                            managerLogObj.salesTeamIsActiveFlag === null
                              ? ""
                              : managerLogObj.salesTeamIsActiveFlag,
                          flag:
                            managerLogObj.flag === null
                              ? ""
                              : managerLogObj.flag,
                          stockStakeHolderName:
                            managerLogObj.stockStakeHolderName === null
                              ? ""
                              : managerLogObj.stockStakeHolderName,
                          remarkName:
                            managerLogObj.remarkName === null
                              ? ""
                              : managerLogObj.remarkName,
                          image:
                            managerLogObj.image === null
                              ? ""
                              : managerLogObj.image,
                        };
                        return managerLogsListData;
                      }
                    ),
              };

              return managerLogsData;
            });
            dispatch(managerLogsSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getManagerLogsDetailedTimeline =
  ({ fromDate, toDate, salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/time-line-by-sales-team-and-dates-new?fromDate=" +
            fromDate +
            "&toDate=" +
            toDate +
            "&salesTeamId=" +
            salesTeamId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((managerLogHeaderObj, index) => {
              const dateObject = moment(managerLogHeaderObj.date, "DD-MM-YYYY");
              const formattedDate = dateObject.format("DD MMM");
              let managerLogsData = {
                index: index + 1,
                id: managerLogHeaderObj.id === null ? "" : managerLogHeaderObj.id,
                date:
                  managerLogHeaderObj.date === null
                    ? ""
                    : managerLogHeaderObj.date,

                areaId:
                  managerLogHeaderObj.areaId !== null
                    ? managerLogHeaderObj.areaId
                    : "",

                checkInOut:
                  managerLogHeaderObj.checkInOut !== null
                    ? managerLogHeaderObj.checkInOut
                    : "",

                description:
                  managerLogHeaderObj.description !== null
                    ? managerLogHeaderObj.description
                    : "",
                endAddress:
                  managerLogHeaderObj.endAddress !== null
                    ? managerLogHeaderObj.endAddress
                    : "",
                entityName:
                  managerLogHeaderObj.entityName !== null
                    ? managerLogHeaderObj.entityName
                    : "",
                extra1:
                  managerLogHeaderObj.extra1 !== null
                    ? managerLogHeaderObj.extra1
                    : "",
                extraIds:
                  managerLogHeaderObj.extraIds !== null
                    ? managerLogHeaderObj.extraIds
                    : "",
                flag:
                  managerLogHeaderObj.flag !== null
                    ? managerLogHeaderObj.flag
                    : "",

                insertTime:
                  managerLogHeaderObj.insertDateTime !== null
                    ? managerLogHeaderObj.insertDateTime.split(" ")[1]
                    : "",

                fromTime:
                  managerLogHeaderObj.fromTime !== null
                    ? managerLogHeaderObj.fromTime
                    : "",

                image:
                  managerLogHeaderObj.image !== null
                    ? managerLogHeaderObj.image
                    : "",
                day: formattedDate,

                isVisitIsOrder:
                  managerLogHeaderObj.isVisitIsOrder !== null
                    ? managerLogHeaderObj.isVisitIsOrder
                    : "",

                managerEndLat:
                  managerLogHeaderObj.managerEndLat !== null
                    ? managerLogHeaderObj.managerEndLat
                    : "",
                managerEndLong:
                  managerLogHeaderObj.managerEndLong !== null
                    ? managerLogHeaderObj.managerEndLong
                    : "",
                managerStartLat:
                  managerLogHeaderObj.managerStartLat !== null
                    ? managerLogHeaderObj.managerStartLat
                    : "",
                managerStartLong:
                  managerLogHeaderObj.managerStartLong !== null
                    ? managerLogHeaderObj.managerStartLong
                    : "",
                otherTask:
                  managerLogHeaderObj.otherTask !== null
                    ? managerLogHeaderObj.otherTask
                    : "",
                otherTaskId:
                  managerLogHeaderObj.otherTask !== null
                    ? managerLogHeaderObj.otherTask.id
                    : "",
                remarkName:
                  managerLogHeaderObj.remarkName !== null
                    ? managerLogHeaderObj.remarkName
                    : "",
                remoteOrder:
                  managerLogHeaderObj.remoteOrder !== null
                    ? managerLogHeaderObj.remoteOrder
                    : "",
                salesPersonName:
                  managerLogHeaderObj.salesPersonName !== null
                    ? managerLogHeaderObj.salesPersonName
                    : "",
                salesTeamId:
                  managerLogHeaderObj.salesTeamId !== null
                    ? managerLogHeaderObj.salesTeamId
                    : "",
                salesTeamPersonAddress:
                  managerLogHeaderObj.salesTeamPersonAddress !== null
                    ? managerLogHeaderObj.salesTeamPersonAddress
                    : "",
                salesTeamPersonAreaIds:
                  managerLogHeaderObj.salesTeamPersonAreaIds !== null
                    ? managerLogHeaderObj.salesTeamPersonAreaIds
                    : "",
                salesTeamPersonId:
                  managerLogHeaderObj.salesTeamPersonId !== null
                    ? managerLogHeaderObj.salesTeamPersonId
                    : "",
                salesTeamPersonName:
                  managerLogHeaderObj.salesTeamPersonName !== null
                    ? managerLogHeaderObj.salesTeamPersonName
                    : "",
                startAddress:
                  managerLogHeaderObj.startAddress !== null
                    ? managerLogHeaderObj.startAddress
                    : "",
                stockStakeHolderId:
                  managerLogHeaderObj.stockStakeHolderId !== null
                    ? managerLogHeaderObj.stockStakeHolderId
                    : "",
                stockStakeHolderName:
                  managerLogHeaderObj.stockStakeHolderName !== null
                    ? managerLogHeaderObj.stockStakeHolderName
                    : "",
                stockStakeHolderTypeId:
                  managerLogHeaderObj.stockStakeHolderTypeId !== null
                    ? managerLogHeaderObj.stockStakeHolderTypeId
                    : "",
                stockStakeHolderTypeName:
                  managerLogHeaderObj.stockStakeHolderTypeName !== null
                    ? managerLogHeaderObj.stockStakeHolderTypeName
                    : "",
                stockStakeHolderTypePrefix:
                  managerLogHeaderObj.stockStakeHolderTypePrefix !== null
                    ? managerLogHeaderObj.stockStakeHolderTypePrefix
                    : "",
                timeDifference:
                  managerLogHeaderObj.timeDifference !== null
                    ? managerLogHeaderObj.timeDifference
                    : "",
                toTime:
                  managerLogHeaderObj.toTime !== null
                    ? managerLogHeaderObj.toTime
                    : "",
                workingType:
                  managerLogHeaderObj.workingType !== null
                    ? managerLogHeaderObj.workingType
                    : "",
                workingTypeId:
                  managerLogHeaderObj.workingType !== null
                    ? managerLogHeaderObj.workingType.id
                    : "",
              };

              return managerLogsData;
            });
            dispatch(managerLogsDetailedMapSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const setManagerLogs = () => async (dispatch) => {
  dispatch(managerLogsSuccess({ row: [] }));
};

export const setManagerLogsDetailedMap = () => async (dispatch) => {
  dispatch(managerLogsDetailedMapSuccess({ row: [] }));
};

export const getUserWorkSummary =
  ({ date }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL + "/user-work-summary?date=" + date,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((userWorkSummaryObj, index) => {
              let userWorkSummaryData = {
                index: index + 1,
                id: userWorkSummaryObj.id === null ? "" : userWorkSummaryObj.id,
                name:
                  userWorkSummaryObj.name === null ? "" : userWorkSummaryObj.name,
                count:
                  userWorkSummaryObj.count === null
                    ? ""
                    : userWorkSummaryObj.count,
                isActive:
                  userWorkSummaryObj.isActive === null
                    ? ""
                    : userWorkSummaryObj.isActive,
                insertDateTime:
                  userWorkSummaryObj.insertDateTime === null
                    ? ""
                    : userWorkSummaryObj.insertDateTime,
              };
              return userWorkSummaryData;
            });
            dispatch(userSummarySuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getManagerLogByDateAndSalesTeam =
  ({ salesTeamId, date }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/by-date-and-sales-team?date=" +
            date +
            "&salesTeamId=" +
            salesTeamId +
            "&flag=0",
        }).then(({ data, success }) => {
          if (success) {
            let managerLogHeaderObj = data.data;
            let managerLogsData = {
              id: managerLogHeaderObj.id === null ? "" : managerLogHeaderObj.id,
              salesTeam:
                managerLogHeaderObj.salesTeam === null
                  ? ""
                  : managerLogHeaderObj.salesTeam,
              salesTeamId:
                managerLogHeaderObj.salesTeam === null
                  ? ""
                  : managerLogHeaderObj.salesTeam.id,
              salesTeamName:
                managerLogHeaderObj.salesTeam !== null &&
                  managerLogHeaderObj.salesTeam.stockStakeHolderType !== null &&
                  managerLogHeaderObj.salesTeam.stockStakeHolderType.prefix !== null
                  ? managerLogHeaderObj.salesTeam.name +
                  " (" +
                  managerLogHeaderObj.salesTeam.stockStakeHolderType.prefix +
                  ")"
                  : "",
              salesTeamTypeId:
                managerLogHeaderObj.salesTeam === null
                  ? ""
                  : managerLogHeaderObj.salesTeam.stockStakeHolderType.id,
              salesTeamTypeName:
                managerLogHeaderObj.salesTeam === null
                  ? ""
                  : managerLogHeaderObj.salesTeam.stockStakeHolderType.name,
              salesTeamTypePrefix:
                managerLogHeaderObj.salesTeam === null
                  ? ""
                  : managerLogHeaderObj.salesTeam.stockStakeHolderType.prefix,
              managerLogsList:
                managerLogHeaderObj.managerLogsList === null
                  ? ""
                  : managerLogHeaderObj.managerLogsList.map(
                    (managerLogObj, index) => {
                      let managerLogsListData = {
                        index: index + 1,
                        id: managerLogObj.id === null ? "" : managerLogObj.id,
                        salesTeamId:
                          managerLogObj.salesTeamId === null
                            ? ""
                            : managerLogObj.salesTeamId,
                        workingTypeId:
                          managerLogObj.workingType === null
                            ? ""
                            : managerLogObj.workingType.id,
                        workingTypeName:
                          managerLogObj.workingType === null
                            ? ""
                            : managerLogObj.workingType.name,
                        areaId:
                          managerLogObj.areaId === null
                            ? ""
                            : managerLogObj.areaId,
                        areaName:
                          managerLogObj.areaName === null
                            ? ""
                            : managerLogObj.areaName,
                        outletId:
                          managerLogObj.outletId === null
                            ? ""
                            : managerLogObj.outletId,
                        entityName:
                          managerLogObj.entityName === null
                            ? ""
                            : managerLogObj.entityName,
                        stockStakeHolderId:
                          managerLogObj.stockStakeHolderId === null
                            ? ""
                            : managerLogObj.stockStakeHolderId,
                        description:
                          managerLogObj.description === null
                            ? ""
                            : managerLogObj.description,
                        fromTime:
                          managerLogObj.fromTime === null
                            ? ""
                            : managerLogObj.fromTime,
                        toTime:
                          managerLogObj.toTime === null
                            ? ""
                            : managerLogObj.toTime,
                        timeDifference:
                          managerLogObj.timeDifference === null
                            ? ""
                            : managerLogObj.timeDifference,
                        date:
                          managerLogObj.date === null ? "" : managerLogObj.date,
                        managerStartLat:
                          managerLogObj.managerStartLat === null
                            ? ""
                            : managerLogObj.managerStartLat,
                        managerStartLong:
                          managerLogObj.managerStartLong === null
                            ? ""
                            : managerLogObj.managerStartLong,
                        startAddress:
                          managerLogObj.startAddress === null
                            ? ""
                            : managerLogObj.startAddress,
                        managerEndLat:
                          managerLogObj.managerEndLat === null
                            ? ""
                            : managerLogObj.managerEndLat,
                        managerEndLong:
                          managerLogObj.managerEndLong === null
                            ? ""
                            : managerLogObj.managerEndLong,
                        endAddress:
                          managerLogObj.endAddress === null
                            ? ""
                            : managerLogObj.endAddress,
                        otherTaskId:
                          managerLogObj.otherTask === null
                            ? ""
                            : managerLogObj.otherTask.id,
                        otherTaskName:
                          managerLogObj.otherTask === null
                            ? ""
                            : managerLogObj.otherTask.name,
                        outletLatitude:
                          managerLogObj.outletLatitude === null
                            ? ""
                            : managerLogObj.outletLatitude,
                        outletLongitude:
                          managerLogObj.outletLongitude === null
                            ? ""
                            : managerLogObj.outletLongitude,
                        extra1:
                          managerLogObj.extra1 === null
                            ? ""
                            : managerLogObj.extra1,
                        extraIds:
                          managerLogObj.extraIds === null
                            ? ""
                            : managerLogObj.extraIds,
                        isVisitIsOrder:
                          managerLogObj.isVisitIsOrder === null
                            ? ""
                            : managerLogObj.isVisitIsOrder,
                        checkInOut:
                          managerLogObj.checkInOut === null
                            ? ""
                            : managerLogObj.checkInOut,
                        insertedUserId:
                          managerLogObj.insertedUserId === null
                            ? ""
                            : managerLogObj.insertedUserId,
                        insertDateTime:
                          managerLogObj.insertDateTime === null
                            ? ""
                            : managerLogObj.insertDateTime,
                        salesPersonName:
                          managerLogObj.salesPersonName === null
                            ? ""
                            : managerLogObj.salesPersonName,
                        flag:
                          managerLogObj.flag === null ? "" : managerLogObj.flag,
                      };
                      return managerLogsListData;
                    }
                  ),
            };

            dispatch(
              managerLogsBySalesTeamAndDateSuccess({ row: managerLogsData })
            );
            return { response: managerLogsData, success };
          }
          return { response: {}, success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getTimeLineForBelowSalesTeamsAndDates =
  ({ fromDate, toDate, salesTeamId, flag }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/time-line-for-below-sales-teams-and-dates-new?fromDate=" +
            fromDate +
            "&toDate=" +
            toDate +
            "&salesTeamId=" +
            salesTeamId +
            "&flag=" +
            flag,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((managerLogHeaderObj, index) => {
              const dateObject = moment(managerLogHeaderObj.date, "DD-MM-YYYY");
              const formattedDate = dateObject.format("DD MMM");
              let managerLogsData = {
                index: index + 1,
                id: managerLogHeaderObj.id === null ? "" : managerLogHeaderObj.id,
                date:
                  managerLogHeaderObj.date === null
                    ? ""
                    : managerLogHeaderObj.date,

                salesTeamId:
                  managerLogHeaderObj.salesTeam !== null &&
                    managerLogHeaderObj.areaId !== null
                    ? managerLogHeaderObj.salesTeam.id
                    : "",

                name:
                  managerLogHeaderObj.salesTeam !== null &&
                    managerLogHeaderObj.salesTeam.name !== null &&
                    managerLogHeaderObj.salesTeam.employeeCode !== null
                    ? managerLogHeaderObj.salesTeam.name +
                    " (" +
                    managerLogHeaderObj.salesTeam.employeeCode +
                    ")"
                    : "",

                salesTeamName:
                  managerLogHeaderObj.salesTeam !== null &&
                    managerLogHeaderObj.salesTeam.name !== null
                    ? managerLogHeaderObj.salesTeam.name
                    : "",
                day: formattedDate,

                salesTeamType:
                  managerLogHeaderObj.salesTeam !== null &&
                    managerLogHeaderObj.salesTeam.stockStakeHolderType !== null
                    ? managerLogHeaderObj.salesTeam.stockStakeHolderType.name
                    : "",

                beatNames:
                  managerLogHeaderObj.beatNames !== null
                    ? managerLogHeaderObj.beatNames
                    : "",

                areaNames:
                  managerLogHeaderObj.areaNames !== null
                    ? managerLogHeaderObj.areaNames
                    : "",

                distanceTravelled:
                  managerLogHeaderObj.distanceTravelled !== null
                    ? managerLogHeaderObj.distanceTravelled
                    : "",

                currentMonthTargetAmount:
                  managerLogHeaderObj.currentMonthTargetAmount !== null
                    ? managerLogHeaderObj.currentMonthTargetAmount
                    : "",

                dayWiseTargetAmount:
                  managerLogHeaderObj.dayWiseTargetAmount !== null
                    ? managerLogHeaderObj.dayWiseTargetAmount
                    : "",

                productiveOrderCount:
                  managerLogHeaderObj.productiveOrderCount !== null
                    ? managerLogHeaderObj.productiveOrderCount
                    : "",

                totalAmount:
                  managerLogHeaderObj.totalAmount !== null
                    ? managerLogHeaderObj.totalAmount
                    : "",

                totalOutletCount:
                  managerLogHeaderObj.totalOutletCount !== null
                    ? managerLogHeaderObj.totalOutletCount
                    : "",

                unvisitedOutletCount:
                  managerLogHeaderObj.unvisitedOutletCount !== null
                    ? managerLogHeaderObj.unvisitedOutletCount
                    : "",

                visitedOutletCount:
                  managerLogHeaderObj.visitedOutletCount !== null
                    ? managerLogHeaderObj.visitedOutletCount
                    : "",

                zeroOrderCount:
                  managerLogHeaderObj.zeroOrderCount !== null
                    ? managerLogHeaderObj.zeroOrderCount
                    : "",
                latitude:
                  managerLogHeaderObj.latitude !== null
                    ? managerLogHeaderObj.latitude
                    : "",
                longitude:
                  managerLogHeaderObj.longitude !== null
                    ? managerLogHeaderObj.longitude
                    : "",
                homeAddress:
                  managerLogHeaderObj.homeAddress !== null
                    ? managerLogHeaderObj.homeAddress
                    : "",
                beats:
                  managerLogHeaderObj.beats === null
                    ? ""
                    : managerLogHeaderObj.beats.map((beatDataObj, index) => {
                      let beatData = {
                        index: index + 1,
                        id: beatDataObj.id === null ? "" : beatDataObj.id,
                        beatName:
                          beatDataObj.beatName !== null
                            ? beatDataObj.beatName
                            : "",
                        areaName:
                          beatDataObj.areaName === null
                            ? ""
                            : beatDataObj.areaName,
                      };
                      return beatData;
                    }),

                managerLogs:
                  managerLogHeaderObj.managerLogs === null
                    ? ""
                    : managerLogHeaderObj.managerLogs.map(
                      (managerLogObj, index) => {
                        let managerLogsListData = {
                          index: index + 1,
                          id: managerLogObj.id === null ? "" : managerLogObj.id,
                          salesTeamId:
                            managerLogObj.salesTeamId === null
                              ? ""
                              : managerLogObj.salesTeamId,
                          workingTypeId:
                            managerLogObj.workingType === null
                              ? ""
                              : managerLogObj.workingType.id,
                          workingTypeName:
                            managerLogObj.workingType === null
                              ? ""
                              : managerLogObj.workingType.name,
                          areaId:
                            managerLogObj.areaId === null
                              ? ""
                              : managerLogObj.areaId,
                          areaName:
                            managerLogObj.areaName === null
                              ? ""
                              : managerLogObj.areaName,
                          remoteOrder:
                            managerLogObj.remoteOrder === null
                              ? ""
                              : managerLogObj.remoteOrder,
                          outletId:
                            managerLogObj.outletId === null
                              ? ""
                              : managerLogObj.outletId,
                          entityName:
                            managerLogObj.entityName === null
                              ? ""
                              : managerLogObj.entityName,
                          stockStakeHolderId:
                            managerLogObj.stockStakeHolderId === null
                              ? ""
                              : managerLogObj.stockStakeHolderId,
                          description:
                            managerLogObj.description === null
                              ? ""
                              : managerLogObj.description,
                          fromTime:
                            managerLogObj.fromTime === null
                              ? ""
                              : managerLogObj.fromTime,
                          toTime:
                            managerLogObj.toTime === null
                              ? ""
                              : managerLogObj.toTime,
                          timeDifference:
                            managerLogObj.timeDifference === null
                              ? ""
                              : managerLogObj.timeDifference,
                          date:
                            managerLogObj.date === null
                              ? ""
                              : managerLogObj.date,
                          managerStartLat:
                            managerLogObj.managerStartLat === null
                              ? ""
                              : managerLogObj.managerStartLat,
                          managerStartLong:
                            managerLogObj.managerStartLong === null
                              ? ""
                              : managerLogObj.managerStartLong,
                          startAddress:
                            managerLogObj.startAddress === null
                              ? ""
                              : managerLogObj.startAddress,
                          managerEndLat:
                            managerLogObj.managerEndLat === null
                              ? ""
                              : managerLogObj.managerEndLat,
                          managerEndLong:
                            managerLogObj.managerEndLong === null
                              ? ""
                              : managerLogObj.managerEndLong,
                          endAddress:
                            managerLogObj.endAddress === null
                              ? ""
                              : managerLogObj.endAddress,
                          otherTaskId:
                            managerLogObj.otherTask === null
                              ? ""
                              : managerLogObj.otherTask.id,
                          otherTaskName:
                            managerLogObj.otherTask === null
                              ? ""
                              : managerLogObj.otherTask.name,
                          outletLatitude:
                            managerLogObj.outletLatitude === null
                              ? ""
                              : managerLogObj.outletLatitude,
                          outletLongitude:
                            managerLogObj.outletLongitude === null
                              ? ""
                              : managerLogObj.outletLongitude,
                          extra1:
                            managerLogObj.extra1 === null
                              ? ""
                              : managerLogObj.extra1,
                          extraIds:
                            managerLogObj.extraIds === null
                              ? ""
                              : managerLogObj.extraIds,
                          isVisitIsOrder:
                            managerLogObj.isVisitIsOrder === null
                              ? ""
                              : managerLogObj.isVisitIsOrder,
                          checkInOut:
                            managerLogObj.checkInOut === null
                              ? ""
                              : managerLogObj.checkInOut,
                          insertedUserId:
                            managerLogObj.insertedUserId === null
                              ? ""
                              : managerLogObj.insertedUserId,
                          insertDateTime:
                            managerLogObj.insertDateTime === null
                              ? ""
                              : managerLogObj.insertDateTime,
                          salesPersonName:
                            managerLogObj.salesPersonName === null
                              ? ""
                              : managerLogObj.salesPersonName,

                          salesTeamName:
                            managerLogObj.salesTeamName === null
                              ? ""
                              : managerLogObj.salesTeamName,

                          salesTeamPersonAreaIds:
                            managerLogObj.salesTeamPersonAreaIds === null
                              ? ""
                              : managerLogObj.salesTeamPersonAreaIds,

                          stockStakeHolderTypeName:
                            managerLogObj.stockStakeHolderTypeName === null
                              ? ""
                              : managerLogObj.stockStakeHolderTypeName,

                          stockStakeHolderTypeId:
                            managerLogObj.stockStakeHolderTypeId === null
                              ? ""
                              : managerLogObj.stockStakeHolderTypeId,

                          salesTeamPersonAddress:
                            managerLogObj.salesTeamPersonAddress === null
                              ? ""
                              : managerLogObj.salesTeamPersonAddress,

                          salesTeamPersonName:
                            managerLogObj.salesTeamPersonName === null
                              ? ""
                              : managerLogObj.salesTeamPersonName,

                          salesTeamPersonId:
                            managerLogObj.salesTeamPersonId === null
                              ? ""
                              : managerLogObj.salesTeamPersonId,

                          image:
                            managerLogObj.image === null
                              ? ""
                              : managerLogObj.image,

                          stockStakeHolderTypePrefix:
                            managerLogObj.stockStakeHolderTypePrefix === null
                              ? ""
                              : managerLogObj.stockStakeHolderTypePrefix,

                          salesTeamIsActiveFlag:
                            managerLogObj.salesTeamIsActiveFlag === null
                              ? ""
                              : managerLogObj.salesTeamIsActiveFlag,
                          flag:
                            managerLogObj.flag === null
                              ? ""
                              : managerLogObj.flag,
                          stockStakeHolderName:
                            managerLogObj.stockStakeHolderName === null
                              ? ""
                              : managerLogObj.stockStakeHolderName,
                          remarkName:
                            managerLogObj.remarkName === null
                              ? ""
                              : managerLogObj.remarkName,
                          image:
                            managerLogObj.image === null
                              ? ""
                              : managerLogObj.image,
                        };
                        return managerLogsListData;
                      }
                    ),
              };

              return managerLogsData;
            });
            dispatch(managerLogsSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };
export const getDateWiseBeatAndOutlets =
  ({ salesTeamId, date }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL1 +
            "/with-date-wise-beat-and-outlets?salesTeamId=" +
            salesTeamId +
            "&date=" +
            date,
        }).then(({ data, success }) => {
          if (success) {
            let managerLogsDataList = data.data.map((managerLogHeaderObj) => ({
              id: managerLogHeaderObj.id === null ? "" : managerLogHeaderObj.id,
              name:
                managerLogHeaderObj.salesTeamName === null
                  ? ""
                  : managerLogHeaderObj.salesTeamName,
              salesTeamId:
                managerLogHeaderObj.salesTeamId === null
                  ? ""
                  : managerLogHeaderObj.salesTeamId,
              userName:
                managerLogHeaderObj.userName === null
                  ? ""
                  : managerLogHeaderObj.userName,
              stockStakeHolderTypeName:
                managerLogHeaderObj.stockStakeHolderTypeName === null
                  ? ""
                  : managerLogHeaderObj.stockStakeHolderTypeName,
              date:
                managerLogHeaderObj.date === null ? "" : managerLogHeaderObj.date,
              status:
                managerLogHeaderObj.status === null
                  ? ""
                  : managerLogHeaderObj.status,
              checkInLat:
                managerLogHeaderObj.checkInLat === null
                  ? ""
                  : managerLogHeaderObj.checkInLat,
              checkInLong:
                managerLogHeaderObj.checkInLong === null
                  ? ""
                  : managerLogHeaderObj.checkInLong,
              checkInTime:
                managerLogHeaderObj.checkInTime === null
                  ? ""
                  : managerLogHeaderObj.checkInTime,
              beatName:
                managerLogHeaderObj.beatName === null
                  ? ""
                  : managerLogHeaderObj.beatName,
              beatId:
                managerLogHeaderObj.beatId === null
                  ? ""
                  : managerLogHeaderObj.beatId,
              outletLogsList: managerLogHeaderObj.outletWithIsVisitOrderFlag?.map(
                (managerLogObj, index) => ({
                  index: index + 1,
                  id: managerLogObj.id === null ? "" : managerLogObj.id,
                  outletId:
                    managerLogObj.outletId === null ? "" : managerLogObj.outletId,
                  firmName:
                    managerLogObj.firmName === null ? "" : managerLogObj.firmName,
                  ownerName:
                    managerLogObj.ownerName === null
                      ? ""
                      : managerLogObj.ownerName,
                  beatId:
                    managerLogObj.beatId === null ? "" : managerLogObj.beatId,
                  outletCode:
                    managerLogObj.outletCode === null
                      ? ""
                      : managerLogObj.outletCode,
                  latitude:
                    managerLogObj.latitude === null ? "" : managerLogObj.latitude,
                  longitude:
                    managerLogObj.longitude === null
                      ? ""
                      : managerLogObj.longitude,
                  status:
                    managerLogObj.status === null ? "" : managerLogObj.status,
                })
              ),
            }));

            dispatch(
              managerLogsBySalesTeamAndDateSuccess({ rows: managerLogsDataList })
            );

            return { response: managerLogsDataList, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        console.error(e.message);
      }
    };
